import { createSlice } from "@reduxjs/toolkit";

type MoveOutState = {
  moveOutDate: string | null;
  moveOutTime: string;
  selectedMoveOutTimeSlot: any | null;
  activeStep: number;
  unitId: string;
  salesOrderId: string;
  moveOutDetails: Record<string, any>;
  availableTimeSlots: any[];
};

const initialState: MoveOutState = {
  moveOutDate: null,
  moveOutTime: "",
  selectedMoveOutTimeSlot: null,
  activeStep: 1,
  unitId: "",
  salesOrderId: "",
  moveOutDetails: {},
  availableTimeSlots: [],
};

const moveOutJourneySlice = createSlice({
  name: "moveOutJourneySlice",
  initialState: initialState,
  reducers: {
    setSelectedMoveOutDate: (state: MoveOutState, action) => {
      state.moveOutDate = action.payload;
    },
    setSelectedMoveOutTime: (state: MoveOutState, action) => {
      state.moveOutTime = action.payload;
    },
    setSelectedMoveOutTimeSlot: (state: MoveOutState, action) => {
      state.selectedMoveOutTimeSlot = action.payload;
      state.moveOutTime = action.payload?.displayTime ?? action.payload?.displayLabel ?? "";
    },
    setActiveStep: (state: MoveOutState, action) => {
      state.activeStep = action.payload;
    },
    resetMoveOutJourney: () => {
      return initialState;
    },
    startMoveOutJourney: (state: MoveOutState, action) => {
      return {
        ...state,
        activeStep: 1,
        moveOutDate: "",
        moveOutTime: "",
        selectedMoveOutTimeSlot: null,
        ...action.payload,
      };
    },
    setMoveOutDetails: (state: MoveOutState, action) => {
      state.moveOutDetails = action.payload;
    },
    setAvailableTimeSlots: (state: MoveOutState, action) => {
      state.availableTimeSlots = action.payload;
    },
  },
});

export const {
  setSelectedMoveOutDate,
  setSelectedMoveOutTime,
  setSelectedMoveOutTimeSlot,
  resetMoveOutJourney,
  setActiveStep,
  startMoveOutJourney,
  setMoveOutDetails,
  setAvailableTimeSlots,
} = moveOutJourneySlice.actions;

export default moveOutJourneySlice.reducer;
